module.exports = __webpack_public_path__ + "static/img/CWJK8.c5cbd576.png";